export default "__VITE_ASSET__CPJVzwa0__"